import PropTypes from 'prop-types';

const LinkGalleryPropType = {
  url: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default LinkGalleryPropType;
